export const labelMessages = {
    lbl: {
        type: ' Type',
        audience: 'Audience',
        eventtype: 'Event Type',
        startdate: 'Event Starting On',
        previous: 'Previous',
        next: 'Next',
        search: 'Search',
        changefilters: 'Change Filter',
        reset: 'Reset',
        apply: 'Apply',
        by: 'by',
        datetime: 'Event Date and Time',
        join: 'Join',
        online: 'Online',
        offline: 'Offline',
        pages:'Pages',
        collaborators: 'Collaborators',
        dialcode:'Dial Code',
        onlineproviderdata: 'Online Provider Data',
        provider:'Provider',
        createnewevent:'Create New Event',
        startdatetime:'Start Date and Time',
        enddatetime:'End Date and Time',
        registrationstartdate:'Registration Start Date',
        registrationenddate:'Registration End Date',
        save:'Save',
        cancel:'Cancel',
        edit:'Edit',
        retire:'Retire',
        enroll:'Enroll',
        unenroll:'Unenroll',
        // createnewevent:'Create',
        // createnewevent:'Create',
        // createnewevent:'Create',
    }
};
